import { z } from 'zod';

export const outreachSuppressionReasonSchema = z.enum([
  'do_not_contact',
  'unsubscribe',
  'hard_bounce',
  'spam_complaint',
  'invalid_email',
  'current_customer',
  'existing_customer',
  'open_deal',
  'inbound_dup',
  'manual_block',
  'other',
]);

export const outreachSuppressionSourceSchema = z.enum([
  'manual',
  'mailmeteor',
  'resend',
  'gdrive',
  'admin',
  'import',
  'other',
]);

export const outreachSuppressionStorageRowSchema = z.object({
  id: z.string().uuid(),
  email: z.string().nullable(),
  domain: z.string().nullable(),
  license_number: z.string().nullable(),
  reason: outreachSuppressionReasonSchema.nullable(),
  source: outreachSuppressionSourceSchema.nullable(),
  notes: z.string().nullable(),
  released_at: z.string().datetime({ offset: true }).nullable(),
  created_at: z.string().datetime({ offset: true }),
  updated_at: z.string().datetime({ offset: true }),
}).strict();

export const outreachSuppressionSafeSchema = z.object({
  id: z.string().uuid(),
  target_type: z.enum(['email', 'domain', 'license_number']),
  target_label: z.string().min(1).max(320),
  reason: outreachSuppressionReasonSchema.nullable(),
  source: outreachSuppressionSourceSchema.nullable(),
  has_notes: z.boolean(),
  released_at: z.string().datetime({ offset: true }).nullable(),
  released_by: z.null(),
  release_reason: z.null(),
  created_at: z.string().datetime({ offset: true }),
  updated_at: z.string().datetime({ offset: true }),
}).strict();

export const outreachSuppressionMatchSchema = z.object({
  lead_id: z.string().uuid(),
  suppression_id: z.string().uuid(),
  reason: outreachSuppressionReasonSchema.nullable(),
  source: outreachSuppressionSourceSchema.nullable(),
  notes: z.null(),
  metadata: z.object({}).strict(),
  created_at: z.string().datetime({ offset: true }),
  match_type: z.enum(['email', 'domain', 'license_number', 'unknown']),
}).strict();

export const outreachSuppressionListSuccessSchema = z.object({
  ok: z.literal(true),
  suppressions: z.array(outreachSuppressionSafeSchema).max(100),
}).strict();

export const outreachSuppressionMutationSuccessSchema = z.object({
  ok: z.literal(true),
  suppression: outreachSuppressionSafeSchema,
}).strict();

export const outreachSuppressionMatchesSuccessSchema = z.object({
  ok: z.literal(true),
  matches: z.array(outreachSuppressionMatchSchema).max(200),
}).strict();
